import { render, staticRenderFns } from "./statics-content.vue?vue&type=template&id=4e7e4233"
import script from "./statics-content.vue?vue&type=script&lang=ts"
export * from "./statics-content.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports